import { clsx } from "clsx"
import { Spinner } from "./Spinner"

type Variant = "primary" | "secondary" | "danger" | "ghost" | "success"
type Size = "sm" | "md" | "lg"

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  loading?: boolean
  icon?: React.ReactNode
}

const VARIANTS: Record<Variant, string> = {
  primary:   "bg-zimrah-600 hover:bg-zimrah-700 text-white shadow-sm shadow-zimrah-200",
  secondary: "bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 shadow-sm",
  danger:    "bg-red-600 hover:bg-red-700 text-white shadow-sm shadow-red-200",
  ghost:     "text-gray-600 hover:bg-gray-100",
  success:   "bg-green-600 hover:bg-green-700 text-white shadow-sm shadow-green-200",
}

const SIZES: Record<Size, string> = {
  sm: "px-3 py-1.5 text-xs rounded-lg gap-1.5",
  md: "px-4 py-2 text-sm rounded-lg gap-2",
  lg: "px-6 py-3 text-sm rounded-xl gap-2",
}

export function Button({
  variant = "secondary", size = "md", loading, icon, children, className, disabled, ...props
}: ButtonProps) {
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={clsx(
        "inline-flex items-center justify-center font-semibold transition-all duration-150",
        "disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-zimrah-500 focus:ring-offset-2",
        VARIANTS[variant],
        SIZES[size],
        className
      )}
    >
      {loading ? <Spinner size="sm" /> : icon}
      {children}
    </button>
  )
}